import React, { useEffect, useState } from "react";
import { MessageCircle, Eye, Send } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { addComment, getApprovedForums } from "../utils/api";
import * as moment from "moment";
import toast from "react-hot-toast";
import { isGuest } from "../utils/isGuest";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";



const ForumMain = () => {
    const [openForumId, setOpenForumId] = useState(null);
    const [newComment, setNewComment] = useState("");
    const navigate = useNavigate()
    const [comment, setComment] = useState({
        text: "",
    })

    const { data: forums, isLoading, refetch } = useQuery({
        queryKey: ["forummain"],
        queryFn: getApprovedForums
    })







    useEffect(() => {
        console.log(forums)
    }, [forums])

    if (isLoading) return <ForumSkeleton />;

    if (!forums?.data?.length) return <NoForumsFound />;

    return (
        <>
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-10">

                {/* Page Header */}
                <div className="max-w-3xl mb-10">
                    <h1 className="text-3xl sm:text-4xl font-bold text-gray-900">
                        Community Forums
                    </h1>
                    <p className="mt-2 text-gray-600 text-sm leading-relaxed">
                        Ask questions, share startup experiences, and learn from founders and mentors.
                    </p>
                </div>

                {/* Forum List */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, ease: "easeOut" }}
                    className="space-y-4"
                >
                    <div className="divide-y divide-gray-200 rounded-xl overflow-hidden bg-white shadow-sm">
                        {forums?.data?.map((forum, index) => (
                            <motion.div
                                key={forum._id}
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: index * 0.05 }}
                            >
                                <QuestionCard
                                    id={forum._id}
                                    title={forum.title}
                                    description={forum.description?.slice(0, 240)}
                                    author={forum?.startupId?.startupName || "Tactos"}
                                    time={moment(forum.createdAt).fromNow()}
                                    comments={forum.comments?.length || 0}
                                />
                            </motion.div>
                        ))}
                    </div>
                </motion.div>
            </div>


        </>
    );
};

export default ForumMain;


const ForumSkeleton = () => {
    return (
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-14">
            {/* Header Skeleton */}
            <div className="max-w-3xl mb-12 space-y-3">
                <div className="h-8 w-64 bg-gray-200 rounded animate-pulse" />
                <div className="h-4 w-full bg-gray-200 rounded animate-pulse" />
            </div>

            {/* Cards Skeleton */}
            <div className="space-y-6">
                {[1, 2, 3].map((i) => (
                    <div
                        key={i}
                        className="bg-white border border-gray-200 rounded-2xl p-6 space-y-4"
                    >
                        <div className="h-5 w-3/4 bg-gray-200 rounded animate-pulse" />
                        <div className="h-4 w-full bg-gray-200 rounded animate-pulse" />
                        <div className="h-4 w-5/6 bg-gray-200 rounded animate-pulse" />

                        <div className="flex justify-between mt-4">
                            <div className="h-3 w-32 bg-gray-200 rounded animate-pulse" />
                            <div className="h-8 w-32 bg-gray-200 rounded animate-pulse" />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};


const NoForumsFound = () => {
    return (
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
            <h2 className="text-2xl font-semibold text-gray-800">
                No forums found
            </h2>
            <p className="mt-2 text-gray-500 text-sm">
                There are no discussions available at the moment.
            </p>
        </div>
    );
};




function QuestionCard({ id, title, description, author, time, comments }) {
    const navigate = useNavigate();

    return (
        <div
            onClick={() => {
                if (isGuest() || !localStorage.getItem("Startuptoken")) {
                    toast.error("Please login to view forum.")
                    navigate("/login")
                } else {
                    navigate(`/forumsmain/${id}`)
                }
            }}
            className="bg-white border border-gray-200 rounded-xl shadow-sm p-5 flex gap-4 cursor-pointer hover:bg-gray-50 transition"
        >
            {/* Content */}
            <div className="flex-1 min-w-0">

                {/* Title */}
                <h3 className="text-lg font-semibold text-gray-900 mb-2 line-clamp-2">
                    {title}
                </h3>

                {/* Description */}
                <p className="text-sm text-gray-600 leading-relaxed mb-3 line-clamp-2">
                    {description} ...
                </p>

                {/* Footer */}
                <div className="flex items-center justify-between text-xs text-gray-500">
                    <div className="flex items-center gap-2">
                        <div className="w-5 h-5 rounded-full bg-gray-300 flex items-center justify-center text-[10px] text-gray-600">
                            {author?.charAt(0).toUpperCase()}
                        </div>

                        <span>
                            Posted by{" "}
                            <span className="font-medium text-[#fd3e3d]">{author}</span>
                        </span>
                    </div>


                    <div className="flex items-center gap-1">
                        <span><MessageCircle /></span>
                        <span>{comments}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}


